const defaultState = false;
export default (state = defaultState, action) => {
  switch (action.type) {
    case 'TOGGLE_COLLAPSE':
      return action.data;
    default:
      return state;
  }
};
